import { faBan, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Badge, Card, Col, Row, Stack } from "react-bootstrap";
import { User } from "../../types/user";
import { Tooltip } from "react-tooltip";
import { Member } from "../../types/member";

interface HouseholdState {
  user: User;
  selectedUser?: User | Member | undefined;
  setSelectedUser?: any;
  setUserType?: any;
  setShowEditFamily?: any;
  showDetails?: boolean;
}

const HouseholdCard = ({ user, selectedUser, setSelectedUser, setUserType, setShowEditFamily, showDetails = true }: HouseholdState) => {
  const [age, setAge] = useState<number | null>();
  const [banDateExpired, setBanDateExpired] = useState<boolean>(false);

  useEffect(() => {
    // Check if birthdate is valid
    if (user?.birthdate && user?.birthdate !== "0000-00-00") {
      const calculateAge = (birthdate: string) => {
        const birthDateObj = new Date(birthdate);
        const today = new Date();

        let age = today.getFullYear() - birthDateObj.getFullYear();
        const monthDiff = today.getMonth() - birthDateObj.getMonth();

        // Adjust age if the birthdate hasn't occurred yet this year
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
          age--;
        }
        return age;
      };

      setAge(calculateAge(user.birthdate));
    } else {
      setAge(null); // Don't calculate age if birthdate is invalid
    }

    //check ban expiration date
    if (user.banned_expiration_at) {
      const expireDate = new Date(user?.banned_expiration_at);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      setBanDateExpired(expireDate <= today);
    }
  }, [user]);

  const onClickEdit = () => {
    setSelectedUser(user);
    setUserType(user?.is_guardian ? "Guardian" : "Member");
    setShowEditFamily(true);
  };

  return (
    <Col key={user.user_id} xs={6} lg={4} className="pb-3">
      <Card
        key={user.user_id}
        className={
          user?.is_banned
            ? "bg-light card-danger card-household-edit-case cursor-pointer"
            : "bg-light card-household-edit-case cursor-pointer"
        }
        onClick={() => onClickEdit()}
      >
        <Card.Body>
          <Row className="me-0">
            <Col xs={showDetails ? 8 : 12}>
              <Stack>
                <h6
                  className={selectedUser?.id === user.id ? "app-orange-text text-start pb-0 mb-0" : "app-header-text text-start pb-0 mb-0"}
                >
                  {user.firstname} {user.preferredname ? "'" + user.preferredname + "'" : ""} {user.lastname}
                </h6>
                {user.relationship === "child" ? (
                  <p className="text-muted text-start first-letter mb-0">
                    {user?.grade && age
                      ? `Grade ${user?.grade} - Age ${age}`
                      : user?.grade
                      ? `Grade ${user?.grade}`
                      : age
                      ? `Age ${age}`
                      : ""}
                  </p>
                ) : (
                  <p className="text-muted text-start first-letter mb-0">{user.relationship}</p>
                )}
              </Stack>
            </Col>
          </Row>
          {user.is_new && (
            <div className="position-absolute bottom-0 end-0">
              <Badge bg="none" className="app-tertiary-color me-2 mb-2">
                New
              </Badge>
            </div>
          )}
          {showDetails && (
            <Row>
              <Col className="col-12 text-end">
                {user?.is_banned === 1 && (
                  <div
                    className="position-absolute top-0 end-0"
                    data-tooltip-id="tooltip-ban"
                    data-tooltip-content={
                      banDateExpired
                        ? `Ban Expired`
                        : `Banned ${user?.banned_expiration_at ? "Until " + user?.banned_expiration_at : "Indefinitely"}`
                    }
                  >
                    <Stack direction="horizontal">
                      <FontAwesomeIcon icon={faBan} className="app-danger-text me-2 mt-2" />
                    </Stack>
                    <Tooltip id="tooltip-ban" place="top" style={{ padding: "5px 10px", zIndex: "100" }} />
                  </div>
                )}
              </Col>
            </Row>
          )}
          {user.is_guardian === 1 && showDetails && (
            <Row>
              <Col className="col-12 text-end">
                {user.is_primary ? (
                  <div className="position-absolute bottom-0 end-0">
                    <Stack direction="horizontal">
                      <small className="small-text app-primary-color-inverse me-1 mb-2 bg-light">Main Contact</small>
                      <FontAwesomeIcon icon={faUserShield} className="app-primary-color-inverse me-2 mb-2" />
                    </Stack>
                  </div>
                ) : (
                  <div className="position-absolute bottom-0 end-0">
                    <Stack direction="horizontal">
                      <text className="p-0 m-0 me-2 app-primary-color-inverse">
                        <small> </small>
                      </text>
                      <FontAwesomeIcon icon={faUserShield} className="app-primary-color-inverse me-2 mb-2" />
                    </Stack>
                  </div>
                )}
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default HouseholdCard;
